// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"691":"af9e7c238adf89988eca","883":"72e0d3af13d0f0204c07"}[chunkId] + ".js";
};